import { userLogIn } from "../helpers/AuthUserHelper";
import { ErrorDanish } from "../helpers/ErrorDanish";

var baseUrl: string | undefined = process.env.REACT_APP_API_SERVER_BASEURL;


// Wait type function.
const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

let REFRESH_IN_PROGRESS: boolean = false;

async function GetUserToken(userLoginObject: { loginUser: any, setLoginUser: Function }) {
    let retryCounter = 5;
    while (REFRESH_IN_PROGRESS) {
        await delay(300);
        if (--retryCounter === 0)
            return null;
    }

    let token = userLoginObject?.loginUser?.token ?? null;
    if (!token)
        return null;

    const jwtDecode = require('jwt-decode');
    const exp = jwtDecode(token).exp;

    if (exp < Date.now() / 1000) {
        if (userLoginObject.loginUser && userLoginObject.loginUser.refreshTokenExpiry &&
            Date.parse(userLoginObject.loginUser?.refreshTokenExpiry) <= Date.now()) {
            return null;
        }

        REFRESH_IN_PROGRESS = true;
        
        await ApiHttpServiceAnon('users/refresh', 'POST',
            { AppUserId: userLoginObject.loginUser.appUserId, RefreshToken: userLoginObject.loginUser.refreshToken })
        .then(async result => {
            if (!result) {
                token = null;
            } else {
                switch(result.status) {
                    case 200: // OK
                        await result.json()
                        .then(resultJson => {
                            // Generic error.
                            if (!resultJson) {
                                token = null;
                            // Success.
                            } else {
                                userLoginObject.loginUser.token = resultJson.token;
                                userLoginObject.loginUser.refreshToken = resultJson.refreshToken;
                                userLoginObject.loginUser.refreshTokenExpiry = resultJson.refreshTokenExpiry;
                                userLogIn(userLoginObject.loginUser);
                                token = resultJson.token;
                            }
                        });
                        break;

                    default:
                        return null;
                }
            }
        })
        .catch(() => {
            token = null;
        });

        REFRESH_IN_PROGRESS = false;
    }

    return token;
}


async function ApiHttpServiceAnon(controller: string, method: TypeControllerMehod,
    body: {} | null = null, querystring: string | null = null, signal: AbortSignal | null = null) {

    if (querystring)
        controller += '?' + querystring

    return await fetch(
        `${baseUrl}${controller}`,
        {
            method: method,
            signal: signal,
            headers: new Headers({
                'Content-Type' : 'application/json',
                'Accept' : 'application/json'
            }),
            body: method === 'GET' || !body ? null : JSON.stringify(body)
        }
    )
    .catch(e => {
        console.log("Something fishy happened: " + e);
        return new Response(null, { status: 500 });  // Internal Error
    });
}


async function ApiHttpServiceAuth(userLoginObject: { loginUser: any, setLoginUser: Function }, controller: string, method: TypeControllerMehod,
    body: {} | null = null, querystring: string | null = null, signal: AbortSignal | null = null) {

    var token = await GetUserToken(userLoginObject);

    // No token.
    if (!token) {
        return new Response(null, { status: 401 });  // Unauthorised
    }
    else {
        if (querystring)
            controller += '?' + querystring

        return await fetch(
            `${baseUrl}${controller}`,
            {
                method: method,
                signal: signal,
                headers: new Headers({
                    'Content-Type' : 'application/json',
                    'Accept' : 'application/json',
                    'Authorization' : 'Bearer ' + token
                }),
                body: method === 'GET' || !body ? null : JSON.stringify(body)
            }
        )
        .catch(e => {
            console.log("Something fishy happened: " + e);
            return new Response(null, { status: 500 });  // Internal Error
        });
    }
}

async function ApiHttpServiceAuthFileUpload(userLoginObject: { loginUser: any, setLoginUser: Function }, controller: string,
    method: TypeControllerMehod, filData: FormData) {

    var token = await GetUserToken(userLoginObject);

    // No token.
    if (!token) {
        return new Response(null, { status: 401 });  // Unauthorised
    }

    return await fetch(
        `${baseUrl}${controller}`,
        {
            method: method,
            headers: new Headers({                
                'Authorization' : 'Bearer ' + token,
                'Accept' : 'application/json'
            }),
            body: filData
        });
}


function GetStakeholderLogoUrl(stakeholderId: number) {
    return `${baseUrl}stakeholders/${stakeholderId}/logo`;
}


function GetStandardApiError(statusCode: number, isWrite: boolean = false) {
    switch(statusCode) {
        case 400:   // Bad Request
            return isWrite ? ErrorDanish["DbWriteValuesError"] : ErrorDanish["DbInvalidRequestError"];
        case 401:   // Unauthorised
            return ErrorDanish['Unauthorized'];
        case 403:   // Forbidden
            return ErrorDanish['Forbidden'];
        case 404:   // Not Found
            return ErrorDanish['IdNotAvailable'];
        case 409:
            return ErrorDanish['ConcurrencyException'];
        default:
            return isWrite ? ErrorDanish["DbGeneralWriteError"] : ErrorDanish["DbFetchDataError"];
        }


}


// Owner
async function OwnerHttpServiceAuth(ownerLoginObject: { ownerStatus: any, setOwnerStatus: Function }, controller: string, method: TypeControllerMehod,
    body: {} | null = null, querystring: string | null = null, signal: AbortSignal | null = null) {

    var token = ownerLoginObject.ownerStatus?.token;

    // No token.
    if (!token)
        return new Response(null, { status: 401 });  // Unauthorised
    else {
        if (querystring)
            controller += '?' + querystring

        return await fetch(
            `${baseUrl}${controller}`,
            {
                method: method,
                signal: signal,
                headers: new Headers({
                    'Content-Type' : 'application/json',
                    'Accept' : 'application/json',
                    'Authorization' : 'Bearer ' + token
                }),
                body: method === 'GET' || !body ? null : JSON.stringify(body)
            }
        )
        .catch(e => {
            console.log("Something fishy happened: " + e);
            return new Response(null, { status: 500 });  // Internal Error
        });
    }
}




export { ApiHttpServiceAnon, ApiHttpServiceAuth, ApiHttpServiceAuthFileUpload, GetStakeholderLogoUrl, GetStandardApiError, OwnerHttpServiceAuth };
